// 系统管理--账号管理模块相关接口

import { get, post, put, del } from 'utils/request';
import { inject } from 'vue'
import url from "config/api.config"   // 兼容写法，防止路由守卫调接口无法注入api.config.js
// const $api= inject("$api") || url;

const $api= url;

// 分页查询用户管理列表
export const getUserList = async(params = {}) => {
  try {
    const res = await get($api.USER_LIST, params);
    return res;
  } catch (error) {
    return Promise.resolve(null);
  }
};

// 查询所有角色
export const getUserRoles = async(params = {}) => {
    try {
      const res = await get($api.GET_USER_ROLES, params);
      return res;
    } catch (error) {
      return Promise.resolve(null);
    }
};

// 添加用户
export const addUser = async(params = null) => {
  try {
    const res = await post($api.UPSERT_USER, params);
    return res;
  } catch (error) {
    return Promise.resolve(null);
  }
};

//编辑用户
export const updateUser = async(params = null) => {
  try {
    const res = await put($api.UPSERT_USER, params);
    return res;
  } catch (error) {
    return Promise.resolve(null);
  }
};

//重置密码
export const updatePassword = async(params = null) => {
    try {
      const res = await put($api.RESET_PWD, params);
      return res;
    } catch (error) {
      return Promise.resolve(null);
    }
};


//修改密码
export const updatePwd = async(oldPassword, newPassword) => {
  try {
    const res = await put($api.CHANGE_PWD + `?oldPassword=${oldPassword}&newPassword=${newPassword}` );
    return res;
  } catch (error) {
    return Promise.resolve(null);
  }
};

// 删除用户
export const delAccount = async(params = null) => {
  try {
    const res = await del($api.DEL_USER + params);
    return res;
  } catch (error) {
    return Promise.resolve(null);
  }
};

// 修改状态
export const updateStatus = async(params = null) => {
    try {
      const res = await put($api.UPDATE_STATE, params);
      return res;
    } catch (error) {
      return Promise.resolve(null);
    }
};



//获取用户信息
export const getUserInfo = async(params = {}) => {
  try {
    const res = await get($api.GET_USER, params);
    return res;
  } catch (error) {
    return Promise.resolve(null);
  }
};



//查询当前用户菜单权限
export const queryMenu = async(params = {}) => {
  try {
    const res = await post($api.AUTH_QUERYMENU, params);
    return res;
  } catch (error) {
    return Promise.resolve(null);
  }
};



//查询当前用户所有权限（非tree）
export const queryPermission = async(params = {}) => {
  try {
    const res = await post($api.AUTH_PERMISSION, params);
    return res;
  } catch (error) {
    return Promise.resolve(null);
  }
};

export const uploadImg = async(data)=>{
  try {
    const res = await post("/file/upload", data);
    return res;
  } catch (error) {
    return Promise.resolve(null);
  }
}

